<template>
  <div :key="registrationId">

    <v-card>
      <v-card-title class="headline">
        Gebruiker toewijzen
      </v-card-title>
      <v-card-text>

        <div v-if="saving">
          <p>
            <v-progress-circular class="mr-1" indeterminate size="25"></v-progress-circular> Registratie wordt toegewezen, even geduld aub...
          </p>
        </div>
        <template v-else>
          <p>
            Selecteer een gebruiker aan wie de registratie toegewezen moet worden. De geselecteerde gebruiker kan verder gaan met het invullen van de registratie.
          </p>

          <FormulateInput
              :disabled="usersLoading || users.length === 0"
              v-model="assignToUserId"
              :options="userOptions"
              type="select"
              validation="required"
              label="Gebruiker toewijzen"
              help="Alleen gebruikers die toegang hebben tot dit formulier worden weergegeven."
          />
        </template>

      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="assignRegistration"
            depressed
            color="primary"
            v-if="!saving"
        >
          Toewijzen
        </v-btn>
        <v-btn color="secondary" outlined @click="$emit('cancel')">
          Annuleren
        </v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RegistrationAssign",
  props: {
    formId: {
      type: String,
      required: true
    },
    registration: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      usersLoading: false,
      saving: false,
      users: [],
      assignToUserId: null,
    }
  },
  computed: {
    registrationId: function() {
      return this.registration._id;
    },
    userOptions() {
      let options = {};
      // Add users to options
      this.users.forEach(user => {
        // Skip if user_id property does not exist. Because it can also contain user.group_id
        if (!user.user_id) {
          return;
        }
        // Add user to options
        options[user.user_id] = user.email;
      });
      return options;
    }
  },
  created () {
    this.getAssignedUsers();
  },
  methods: {
    /**
     * Assign a registration to a user.
     *
     * @returns {Promise<void>}
     */
    async assignRegistration() {
      this.saving = true

      let payload = {
        user_id: this.assignToUserId,
      }

      try {
        let response = await axios.post('api/form/' + this.formId + '/registrations/' + this.registrationId + '/assign', payload);

        if (response && response.status === 200) {
          this.$toast.success("Gebruiker is toegewezen.");
          // Emit event
          this.$emit('assign-success');
        }

      } catch (error) {
        console.log(error);
        this.$toast.error('Gebruiker kon niet toegewezen worden.');
      }

      this.saving = false;
    },
    /**
     * Get users who can be assigned to this form.
     */
    getAssignedUsers() {
      this.usersLoading = true;

      axios.get('api/form/'+this.formId+'/assigned-users')
          .then(response => {
            this.users = response.data;
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.usersLoading = false)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>